Alerts = require 'views/lib/alerts'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
addToTeamTemplate = require 'views/templates/popover_add_to_team'
l = require 'lib/localize'
localizeServerError = require 'lib/localize-server-error'

module.exports = class AddToTeamPopoverView extends View
  viewTitleKey: 'add to team'

  events:
    'click .js-add-to-team': 'addToTeam'

  render: ->
    teamType = l(['products', if @options.isBC then 'bc' else 'enterprise'])

    @$el.html(addToTeamTemplate({ teamType }))
    @

  showError: (message) ->
    errorMessage = localizeServerError(message)
    Alerts.showLiteralText(errorMessage, 'error', 'alert', 5000)

  addToTeam: (e) ->
    Util.preventDefault(e)

    @$('.js-add-to-team').attr('disabled', true).addClass('disabled')

    @options.org.addMember(@model).then =>
      if @options.showAlert ?= false
        Alerts.show('added to team', 'confirm', 'info', 3000)

      PopOver.hide()
    .catch (err) =>
      @showError(err.message)
      PopOver.hide()



// WEBPACK FOOTER //
// ./app/scripts/views/member/add-to-team-popover-view.coffee